<template>
  <div class="global-container">
    <div class="video-container">
      <img v-if="isMobile" class="video-poster" src="@/assets/images/matr1xFireIntro/m_global_banner.png" alt="mask" />
      <img v-else class="video-poster" src="@/assets/images/matr1xFireIntro/global_banner.png" alt="mask" />
    </div>
    <div class="global-main-container">
      <div class="global-content mat1x-fire-intro-main-width">
        <div class="left-text">
          <div class="title">
            <div v-for="(item, index) in processString(mapText && mapText.title || '')" :key="index">
              <springText class="item-title" :text="item"></springText>
            </div>
          </div>
          <svg-icon icon-class="matr1x_fire_intro_player" class-name="icon-svg"
            style="width: 44px; height: 44px"></svg-icon>
          <p>
            {{ mapText && mapText.content }}
          </p>
        </div>
      </div>
      <div class="map-image">
        <img src="@/assets/images/matr1xFireIntro/map_scatter.png" alt="map" />
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import TitleComp from "../title";
export default {
  name: "GlobalPlayer",
  mixins: [responsiveMixin],
  components: { springText, TitleComp },
  props: {
    mapText: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    processString(input) {
      if (!input) return [""];
      if (input.includes("\n")) {
        return input.split("\n");
      } else {
        return [input];
      }
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>